import { CheckCircleIcon } from "@phosphor-icons/react";
import { useIntl } from "react-intl";

import { CollapsibleCard } from "@/components/CollapsibleCard/CollapsibleCard";
import {
  BaggageDetails,
  NoBaggageDetails,
} from "@/features/flights/components/BaggageAllowance";
import type { GetFlightAvailabilityTokenDirectionalBaggageV2 } from "@/types/codegen";

type Props = {
  data?: GetFlightAvailabilityTokenDirectionalBaggageV2 | null;
};

export const IncludedBaggage = ({ data }: Props) => {
  const intl = useIntl();

  return (
    <CollapsibleCard
      backgroundColor="surface"
      expandedByDefault={false}
      title={
        <div className="flex items-center gap-1">
          <CheckCircleIcon size={20} color="var(--color-core-accent-500)" />
          <span>
            {intl.formatMessage({
              id: "travellers.includedFreeBaggage",
              defaultMessage: "Included free baggage",
            })}
          </span>
        </div>
      }
    >
      <div className="border-t border-stroke-neutral-soft pt-4">
        <ul className="space-y-2 *:not-last:pb-2">
          {data?.carryOn && data.carryOn.length > 0 ? (
            data.carryOn.map((carryOnBaggage, index) => (
              <li key={carryOnBaggage.raw + index}>
                <BaggageDetails
                  baggageType={
                    carryOnBaggage.isSmallBag ? "handBag" : "carryOn"
                  }
                  data={carryOnBaggage}
                />
              </li>
            ))
          ) : (
            <li>
              <NoBaggageDetails baggageType="carryOn" />
            </li>
          )}

          {data?.baggage && data.baggage.length > 0 ? (
            data.baggage.map((checkedBaggage, index) => (
              <li key={checkedBaggage.raw + index}>
                <BaggageDetails baggageType="checked" data={checkedBaggage} />
              </li>
            ))
          ) : (
            <li>
              <NoBaggageDetails baggageType="checked" />
            </li>
          )}
        </ul>
      </div>
    </CollapsibleCard>
  );
};
